import { CreateFeedInsertRequestBody } from "../apis";
import { FeedInsertFormValues } from "../components/forms";
import { FeedInsertType } from "../constants";

export const convertFeedInsertFormDataToCreateRequestBody = (
  formData: FeedInsertFormValues
): CreateFeedInsertRequestBody => {
  const mediaList = formData.media.map((media) => ({
    mediaId: String(media.media?.id),
    allowDisplayInFullScreenMode: media.allowDisplayInFullScreenMode,
    previewId: media.thumbnail?.id || undefined,
    redirection: {
      productVariantIds:
        media.productVariants?.map((product) => product.id) || undefined,
      productSetId: media.productSet?.id || null
    }
  }));

  return {
    name: formData.name,
    form: formData.form,
    type: formData.type,
    header: formData.header,
    text: formData.text,
    headerBackgroundMediaId: formData.headerBackgroundMedia?.id || null,
    backgroundMediaId: formData.backgroundMedia?.id || null,
    spaceBeforeSliderStart: formData.spaceBeforeSliderStart || null,
    media:
      formData.type === FeedInsertType.SingleMedia
        ? [mediaList[0]]
        : formData.type === FeedInsertType.MultipleMedia
          ? mediaList
          : [],
    metadata: {
      productVariantIds:
        formData.type === FeedInsertType.Products
          ? formData.products.map((product) => product.id) || undefined
          : undefined,
      productSetId: formData.productSet?.id || null
    }
  };
};
